<template>
	<div>
		<Header v-if="!isMobile&&path!='/turnCenter'"/>
		<header-wx v-if="isMobile&&path!='/turnCenter'"/>
		<div class="mainContentBox">
			<router-view></router-view>
		</div>
		<Footer v-if="!isMobile&&path!='/turnCenter'" />
		<footer-wx v-if="isMobile&&path!='/turnCenter'" />
	</div>
</template>

<style lang="less" scoped>
	.mainContentBox {
		margin: 0 auto;
		min-height: calc(100vh - 80px - 170px);
	}
</style>

<script>
	import Header from "./Header.vue";
	import Footer from "./Footer.vue";
	import HeaderWx from './HeaderWx';
	import FooterWx from './FooterWx';
	export default {
		name:'CommonLayout',
		components: {
			Header,
			Footer,
			HeaderWx,
			FooterWx,
		},
		data(){
			return{
				path:''
			}
		},
		watch:{
			$route(to,from){
				this.path = this.$route.path
			}
		},
		mounted(){
			this.path = this.$route.path
		},
		methods:{

		}
	}
</script>